function FeaturedIcon({
  icon,
  variant = 'default',
}: {
  icon: React.ReactNode;
  variant?: 'default' | 'error' | 'warning' | 'success' | 'info';
} & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="featured-icon"
      data-variant={variant}
      className="group/featured-icon flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full border-7 data-[variant=default]:border-ui-selected data-[variant=error]:border-error-main/30 data-[variant=info]:border-info-main/30 data-[variant=success]:border-success-main/30 data-[variant=warning]:border-warning-main/30"
    >
      <div className="flex size-6.5 shrink-0 items-center justify-center rounded-full border border-secondary-dark fill-secondary-dark group-data-[variant=error]/featured-icon:border-error-dark group-data-[variant=error]/featured-icon:fill-error-dark group-data-[variant=info]/featured-icon:border-info-dark group-data-[variant=info]/featured-icon:fill-info-dark group-data-[variant=success]/featured-icon:border-success-dark group-data-[variant=success]/featured-icon:fill-success-dark group-data-[variant=warning]/featured-icon:border-warning-dark group-data-[variant=warning]/featured-icon:fill-warning-dark">
        {icon}
      </div>
    </div>
  );
}

export { FeaturedIcon };
